/**
 * Backend Configuration
 * Centralized configuration for API endpoints
 * 
 * Setup:
 * - Frontend (React): localhost:3000 (dev) → Netlify (prod)
 * - Backend (Flask): EC2 instance at 3.138.192.243:5000 (dev & prod)
 */

// Frontend Configuration
export const FRONTEND_CONFIG = {
  // Development frontend runs on port 3000
  DEV_PORT: 3000,
  DEV_URL: 'http://localhost:3000',
  
  // Production frontend is deployed on Netlify
  PROD_URL: 'https://audiovibration.netlify.app'
};

/**
 * Resolve backend base URL at runtime to avoid mixed content when on HTTPS.
 * - If page is served over HTTPS: always use /api (Netlify proxy) so browser doesn't block.
 * - If production build: use /api (Netlify proxy).
 * - Otherwise: use REACT_APP_BACKEND_URL or direct EC2 URL for local dev over HTTP.
 */
function getBackendBaseUrl(): string {
  if (typeof window !== 'undefined' && window.location?.protocol === 'https:') {
    return '/api'; // Same-origin proxy when on HTTPS (avoids mixed content)
  }
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }
  return process.env.REACT_APP_BACKEND_URL || 'http://3.138.192.243:5000';
}

export const BACKEND_CONFIG = {
  // Backend URL: use getter so HTTPS pages always use /api (no mixed content)
  get BASE_URL(): string {
    return getBackendBaseUrl();
  },
  
  // API Endpoints
  ENDPOINTS: {
    HEALTH: '/health',
    GENERATE_VIBRATIONS: '/generate-vibrations',
    GENERATE_AND_DOWNLOAD: '/generate-and-download',
    DOWNLOAD: '/download',
    LIST_OUTPUTS: '/list-outputs'
  },
  
  // Request Configuration
  TIMEOUT: 30000, // 30 seconds
  MAX_FILE_SIZE: 50 * 1024 * 1024, // 50MB
  
  // Retry Configuration
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000 // 1 second
};

export default BACKEND_CONFIG;